import React, { useEffect, useRef, useState } from 'react'
import { FormValues } from 'donate/types'
import { FormikErrors } from './types'
import { connect } from 'formik'
import { scrollToRef, toSentence } from 'shared'

export const GeneralError = connect<{ currentSubmitCount?: number }, FormValues>(({ formik }) => {
  const [message, setMessage] = useState<string | undefined>()
  const ref = useRef<HTMLDivElement | null>(null)

  useEffect(() => {
    if (!formik.isValidating && !formik.isSubmitting) {
      const errors = {
        ...(!formik.isValid ? formik.errors : undefined),
        // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
        ...(formik.status && formik.status.customErrors ? formik.status.customErrors : undefined),
      }

      setMessage(errorMessage(errors))
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [formik.isSubmitting, formik.status])

  useEffect(() => {
    message && scrollToRef(ref)
  }, [message])

  return <div ref={ref}>{message && <div className="generic-value negative py-3">{message}</div>}</div>
})

const errorMessage = (errors: FormikErrors): string | undefined => {
  if (errors.base) return errors.base
  if (errors.stripe_token && /The payment is blocked due to a high likelihood of chargeback/.test(errors.stripe_token))
    return i18n.t('errors.messages.stripe_try_again')
  if (errors.client_reference) return i18n.t('donate.errors.client_reference_taken')

  const fields = Object.keys(errors).map(localizedFieldName).filter(Boolean)
  if (fields.length) return i18n.t('errors.messages.summary', { fields: toSentence(...fields) })

  if (errors.captcha_solution) return i18n.t('donate.errors.verification_error')
  if (errors._captcha_complete) return i18n.t('donate.errors.captcha_required')
}

const localizedFieldName = (field: string) => i18n.t(`donate.attributes.${field}`, { defaultValue: '' })
